<template>
	<div class="page-logistics-info">
		<div class="pg-breadcrumb">
            <div class="breadcrumb-item em">送貨上門</div>
            <div class="breadcrumb-item">設置送貨上門</div>
        </div>

		<div class="card-block">
            <Form inline class="pg-form-inline">
               <Form :label-width="150">
                    <Row>
                        <Col span="11" push="6">
                        	<FormItem>
								<div slot="label" class="form-label">
								    <em class="red">* </em>
								    <span>送貨門店</span>
								</div>
							    <Select size="large" placeholder="選擇可送貨門店" v-model="form.store_id" style="width:100%">
							        <Option :value="item.ReceivingID" v-for="(item, index) in shopList"
							                :key="item.ReceivingID">{{item.ReceivingName}}
							        </Option>
							    </Select>
							</FormItem>
                            <br>
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>快遞單號</span>
                                </div>
                                <Input size="large" clearable v-model="form.order" @keyup.enter.native="handleSearch()"></Input>
                            </FormItem>
                            <FormItem>
                                <div class="pg-btn-wrap pg-form-btn">
                                    <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        			<div class="pg-btn style2" @click="handleSettings">設定送貨上門</div>
                                </div>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Form>
        </div>

		<div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="step-wrap" v-if="detail && detail.length">
                <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                    <div class="left">
                        <div class="l-date">
                            <span>{{item.date}}</span>
                            <span>{{item.week}}</span>
                        </div>
                        <div class="l-time">{{item.time}}</div>
                    </div>
                    <div class="right">
                        <div class="r-address">{{item.describe}}</div>
                    </div>
                </div>
            </div>

            <div class="data-null" v-else>
                <img src="../../../assets/images/null-data.png" alt="" draggable="false">
                <div>暫無數據</div>
            </div>
        </div>
	</div>
</template>

<script>
	import Store from '../../../assets/js/store.js'
	export default {
		data()
        {
            return {
                successAudio: 'music-success.mp3', //成功音效
                errorAudio: 'music-fail.mp3', //失敗音效
                isPaying: false,
                isLoading: false,
                detail: [],
                shopList: [],
                form: {
                    order: '',
                    store_id: 132
                },
            };
        },
		components: {	
		},
		computed: {
		},
		created() {
			this.getShopList();
		},
		methods: {
			getShopList()
			{
			    this.$Rq.requestAuth({
			        url: this.$Api.pickAddress,
			        method: 'get',
			        data: {
                        company_id: 0,
			            type: 1
			        }
			    }).then((res) =>
			    {
			    	let resData = res.data.data.filter(it=>it.company_id != 15);;
                    let tempArr = [];

			        if (res.code == 0)
			        {
			        	for (let i = 0; i < resData.length; i++)
                        {
                        	if(resData[i].delivery == 1){
                        		tempArr.push({
                                	ReceivingAddress: resData[i].ReceivingAddress,
                                	ReceivingID: resData[i].ReceivingID,
                                	ReceivingName: resData[i].ReceivingName,
                                	delivery: resData[i].delivery
                            	});
                        	}
			        	}
			            this.shopList = tempArr;
			        }
			    });
			},
			getList(){
				this.isLoading = true;
				this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + this.form.order ,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];

                        for (let i = 0; i < resData.length; i++)
                        {
                            let datetime = this.getDateTime(resData[i].created_at);

                            tempArr.push({
                                id: resData[i].id,
                                date: datetime.date,
                                week: datetime.week,
                                time: datetime.time,
                                describe: resData[i].remarks
                            });
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isLoading = false;
                });
			},
			handleSearch()
            {
            	let form = this.form;
                if (form.order === '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }
                this.getList();
            },
			handleSettings(){
				let form = this.form;
                this.isPaying = true;
                if (form.order === '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                }
                if (form.store_id === '' || form.store_id === 0)
                {
                    this.$Utils.showTipInfo('請輸入可送貨門店');
                    return;
                }

				this.isLoading = true;
				this.$Rq.requestAuth({
                    url: this.$Api.setDeliveryStatus,
                    method: 'post',
                    data: {
                    	order: form.order,
                    	ReceivingID: form.store_id
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        let audio = new Audio();
                        audio.src = require('@/assets/audio/'+ this.successAudio);
                        audio.play();
                        this.isPaying = false;
                        this.getList();
                    }else{
                        this.$Utils.showTipInfo(res.msg);
                        let audio = new Audio();
                        audio.src = require('@/assets/audio/'+ this.errorAudio);;
                        audio.play();
                        this.isPaying = false;
                        this.getList();
                    }
                }).catch((err) =>
                {
                    this.isLoading = false;
                    this.getList();
                });
			},

			getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum(year)}-${this.formateNum(month)}-${this.formateNum(day)}`,
                    time: `${this.formateNum(hour)}:${this.formateNum(minute)}:${this.formateNum(second)}`,
                    week: weekList[week]
                };
            },

            formateNum(num)
            {
                return num > 9 ? num : '0' + num;
            }
		}
	}
</script>

<style lang="scss" scoped>
	@import "setDelivery.scss";
</style>